import { Box, ButtonProps, IconButton, Tooltip } from '@mui/material';
import RemarkIcon from '@Components/Icons/RemarkIcon';

const RemarkButton = (props: ButtonProps) => {
  return (
    <Tooltip title="เพิ่มหมายเหตุส่วนท้าย" arrow placement="top">
      <Box component={'span'}>
        <IconButton
          {...props}
          sx={{
            border: 1,
            borderRadius: 1,
            borderColor: 'secondary.lighter',
            padding: 1,
            width: '16px',
            height: '16px',
          }}
          color="inherit"
          size="small"
        >
          <RemarkIcon fontSize="small" />
        </IconButton>
      </Box>
    </Tooltip>
  );
};

export default RemarkButton;
